/**
 Given a sample (or container) id, we hydrate a richer object from
 data available in the client-side store.

 No fetching is performed here.
*/
import {ContainerInfo} from 'constants/SampleConstants';
import {BioentityInfo} from 'folder-items/FileConstants';
import {getStore} from 'redux-stores/Store';
import StorableStore from 'samples/StorableStore';

export function hydrateBioentityFromSampleId(bioentityId: string): BioentityInfo | null {
  const {fileSummariesById} = getStore().getState().models;
  return fileSummariesById[bioentityId] != null
    ? {
        id: bioentityId,
        name: fileSummariesById[bioentityId].name,
        displayLabel: fileSummariesById[bioentityId].displayLabel,
      }
    : null;
}

export function hydrateContainerFromId(containerId: string): ContainerInfo | null {
  const containerInfo = StorableStore.getContainerSummary(containerId);
  return containerInfo != null
    ? {
        id: containerId,
        name: containerInfo.name,
        barcode: containerInfo.barcode,
      }
    : null;
}
